import BronzeBadge from 'assets/images/bronze-badge.svg?react';
import GoldBadge from 'assets/images/gold-badge.svg?react';
import SilverBadge from 'assets/images/silver-badge.svg?react';
import StandardBadge from 'assets/images/standard-badge.svg?react';

type VendorBadgeProps = {
  badge: string;
  link: string;
};

const BADGES: Record<
  string,
  {label: string; Icon: React.FC<React.SVGProps<SVGSVGElement>>; className: string}
> = {
  gold: {label: 'سطح طلایی', Icon: GoldBadge, className: 'bg-warning-surface text-warning-heavy'},
  silver: {label: 'سطح نقره‌ای', Icon: SilverBadge, className: 'bg-gray-03 text-gray-09'},
  bronze: {label: 'سطح برنزی', Icon: BronzeBadge, className: 'bg-orange-peach text-orange-deep'},
  standard: {label: 'سطح پایه', Icon: StandardBadge, className: 'bg-orange-pale text-orange-vivid'}
};

const VendorBadge: React.FC<VendorBadgeProps> = ({badge, link}) => {
  const badgeData = BADGES[badge];

  if (!badgeData) {
    return null;
  }

  const {Icon, label, className} = badgeData;

  return (
    <button
      type="button"
      className={`flex items-center gap-2 rounded-lg px-4 py-1 text-body-sm-emphasis shadow-sm ${className}`}
      onClick={() => window.open(link, '_blank', 'noopener,noreferrer')}
    >
      <Icon aria-hidden />
      {label}
    </button>
  );
};

export default VendorBadge;
